import { render } from "./StatsTabs.vue?vue&type=template&id=2c2e1142"
import script from "./StatsTabs.vue?vue&type=script&lang=js"
export * from "./StatsTabs.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./StatsTabs.vue?vue&type=style&index=0&id=2c2e1142&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__